import React, { createContext, FC, PropsWithChildren, useCallback, useState } from 'react'

type NotiContainerType = HTMLDivElement | null

interface Props {
  // 캡슐화를 위해 id 대신 state 에 ref 로 notiContainer 저장
  notiContainer: NotiContainerType
}

const NotificationContext = createContext<Props>({ notiContainer: null })

const NotificationProvider: FC<PropsWithChildren> = ({ children }) => {
  const [notiContainer, setNotiContainer] = useState<NotiContainerType>(null)
  const onRefChange = useCallback((container: NotiContainerType) => {
    setNotiContainer(container)
  }, [])

  return (
    <NotificationContext.Provider value={{ notiContainer }}>
      <div ref={onRefChange} />
      {children}
    </NotificationContext.Provider>
  )
}

export { NotificationContext }
export default NotificationProvider
